<template>
  <div>
    <el-row style="padding-bottom:10px;" @keyup.enter.native="search">
      <el-col :span="24">
        设备编号：
        <el-input class="search-input" v-model="deviceId" placeholder="请输入设备编号"></el-input>&nbsp;&nbsp;经销商：
        <DropdownSelect
          v-model="dealerId"
          :action="api.admin.dealer.all"
          textField="name"
          valueField="id"
        ></DropdownSelect>
        <el-button type="primary" @click="search">搜索</el-button>
      </el-col>
    </el-row>
    <page-table
      :data-api="this.api.admin.order"
      :viewable="false"
      keyField="id"
      :deletable="false"
      :editable="false"
    >
      <el-table-column prop="id" label="编号" width="80"></el-table-column>
      <el-table-column prop="deviceId" label="设备编号"></el-table-column>
      <el-table-column prop="deviceCategoryName" label="设备名称"></el-table-column>
      <el-table-column prop="dealerName" label="经销商"></el-table-column>
      <el-table-column prop="shopName" label="门店"></el-table-column>
      <el-table-column prop="staffName" label="员工"></el-table-column>
      <el-table-column prop="status" label="状态" :formatter="statusFormatter"></el-table-column>
      <el-table-column prop="payType" label="支付类型" :formatter="payTypeFormatter"></el-table-column>
      <el-table-column prop="payTime" label="启动时间" :formatter="dateFormatter"></el-table-column>
      <el-table-column prop="workDeadline" label="结束时间" :formatter="dateFormatter"></el-table-column>
    </page-table>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      deviceId: null,
      dealerId: null
    };
  },
  created: function() {
    let that = this;
    let query = that.getQuery();
    that.deviceId = query.deviceId ? parseInt(query.deviceId) : null;
    that.dealerId = query.dealerId ? parseInt(query.dealerId) : null;
  },
  methods: {
    dateFormatter(row, column, cellValue, index) {
      if (!cellValue) {
        return cellValue;
      }
      return this.dateFormat("yyyy-mm-dd HH:MM:SS",new Date(cellValue));
    },
    statusFormatter(row, column, cellValue, index) {
      if (0 == cellValue) {
        return "待支付";
      } else if (1 == cellValue) {
        return "启动中";
      } else if (2 == cellValue) {
        return "启动成功";
      } else if (3 == cellValue) {
        return "启动失败";
      } else if (4 == cellValue) {
        return "订单关闭";
      }
      return cellValue;
    },
    payTypeFormatter(row, column, cellValue, index) {
      if (1 == cellValue) {
        return "管理员";
      } else if (2 == cellValue) {
        return "门店";
      }
      return cellValue;
    },
    search() {
      let params = this.getQuery();
      params.deviceId = this.deviceId;
      params.typeId = this.typeId;
      params.dealerId = this.dealerId;
      params.page = 1;
      let that = this;
      this.$router.replace({ query: params }, null, function() {
        that.$router.go(0);
      });
    },
    getQuery() {
      return Object.assign({}, this.$route.query);
    }
  }
};
</script>

<style scoped>
.search-input {
  width: 150px;
}
</style>


// WEBPACK FOOTER //
// List.vue?5168c9ec